import React, {Component} from "react";
import { Form, Input, Button, message } from 'antd';
import {Redirect} from 'react-router-dom';
import {reqLogin, reqLoginNum} from '../../api';
import memoryUtils from "../../utils/memoryUtils";
import storageUtils from "../../utils/storageUtils";
import './login.less';

/**
 * 登录的路由组件
 */
export class Login extends Component {

    state = {
        loginNum:0
    };

    toFind =()=> {
        this.props.history.push("/forget");
    };
    handleSubmit = (event) => {
        //组织表单的默认行为
        event.preventDefault();
        //对所有表单字段进行校验
        this.props.form.validateFields(async(err, values) => {
            if (!err) {
                const {username,password} = values;
                //将数据封装成formData
                let loginData = new FormData();
                loginData.append("username",username);
                loginData.append("password",password);
                const result = await reqLogin(loginData);
                memoryUtils.user = result.data;
                storageUtils.saveUser(result.data);
                if (result.code === '000000') {
                    message.success("登录成功");
                    //跳转到主页面
                    this.props.history.replace("/");
                } else {
                    message.error("用户名或密码有误");
                }
            }
        });
    };
    componentDidMount = async () => {
        const result = await reqLoginNum();
        if(result.code==="000000"){
            this.setState({
                loginNum:result.data
            })
        }
        /* let loginData = new FormData();
        loginData.append("username","test");
        loginData.append("password","123456");
        const result1 = await reqLogin(loginData);
        memoryUtils.user = result1.data;
        storageUtils.saveUser(result1.data);
        if (result.code === '000000') {
            message.success("登录成功");
            //跳转到主页面
            this.props.history.replace("/");
        } else {
            message.error("用户名或密码有误");
        } */
        
    };

    render (){
        const user = memoryUtils.user;
        if(user && user.userId){
            //跳转登录页(在render中)
            return <Redirect to='/'/>;
        }

        const form = this.props.form;
        const { getFieldDecorator } = form;

        return (
            <div className="login">
                <img className="login_l" src={require('./images/login_bg_l.jpg')} />
                <img className="login_r" src={require('./images/login_bg_r.jpg')} />
                {/*<img className="login_t" src={require('./images/title.png')} />*/}
                <div className="login_box">
                    <div className="login_logo">
                        <img src={require('./images/login.png')}/>
                    </div>
                    <div className="login_form">
                        <Form onSubmit={this.handleSubmit} className="login-form">
                            <Form.Item>
                                <div className="login_input">
                                    {getFieldDecorator('username', {
                                        rules: [{ required: true, message: '请输入用户名!' },],
                                    })(
                                        <Input
                                            className="login_ipt icon_user"
                                            placeholder="用户名"
                                        />,
                                    )}
                                </div>
                            </Form.Item>
                            <Form.Item>
                                <div className="login_input">
                                    {getFieldDecorator('password', {
                                        rules: [{ required: true, message: '请输入密码!' }],
                                    })(
                                        <Input
                                            autoComplete={"off"}
                                            className="login_ipt icon_pass"
                                            type="password"
                                            placeholder="密码"
                                        />,
                                    )}
                                </div>
                            </Form.Item>
                            <div className='forgot'><a onClick={this.toFind}>忘记密码？</a></div>
                            <Form.Item>
                                <div className="login_input">
                                    <Button type="primary" htmlType="submit" className="login_submit">
                                        登   录
                                    </Button>
                                </div>
                            </Form.Item>
                        </Form>
                    </div>
                    <div className="login_num">
                        累计访问量{this.state.loginNum}次
                    </div>
                </div>
                <div className="login_foot">
                    技术支持：
                    <a style={{ color:'#12c4ed' }} href="http://www.ugion.com/">上海域圆信息科技有限公司</a>
                </div>
            </div>
        )
    }
}

/**
 * 包装Form组件形成新的组件Form(Login)
 * 新组件会向Form组件提供强大的对象属性：from
 */
const WrapLogin = Form.create()(Login);
export default WrapLogin;